import { NavbarStyled } from "./styled";
import { ROUTE_PATH } from "utils/constants/routePath";
import { useNavigate } from "react-router-dom";
import {
  LanguageWidget,
  NotificationWidget,
  MemberActionWidgets,
} from "widgets";

const Navbar = () => {
  const navigate = useNavigate();
  return (
    <NavbarStyled>
      <div className="navbar_left">
        <LanguageWidget />
        <NotificationWidget />
      </div>
      <img
        className="logo"
        src="/assets/images/logos/logo.svg"
        alt="logo"
        onClick={() => navigate(ROUTE_PATH.HOME)}
      />
      <div className="navbar_right">
        <MemberActionWidgets />
      </div>
    </NavbarStyled>
  );
};

export default Navbar;
